import {createPaginatedSlice} from '../createPaginatedSlice';
import {Bank, loadBanks} from '../../services/banks.servcice';

const banksSlice = createPaginatedSlice<Bank>({
    name: 'banks',
    fetchFn: loadBanks,
    defaultSortBy: 'name',
});

export const banksActions = banksSlice.actions;
export const banksReducer = banksSlice.reducer;
